<template>
  <div id="app" class="main"> 
    
    <site-nav 
      companyName="Amnehagen IT AB"
      :navItems="navItems" />
    
    <company-intro 
      id="Home"
      v-observe-visibility="sectionVisibilityChanged"
      companyName="Amnehagen" 
      companyBranch="IT Consulting" 
      companySkillset="Software Infrastructure Web" 
      companyPhone="+46723359559" 
      companyEmail="contact@amnehagenit.com"
      :pointerLink="navItems[1].name" />

<!--     <customer-story  -->
<!--       id="Story1" -->
<!--       :storyTitle="customerStories[0].storyTitle" -->
<!--       :storyBody="customerStories[0].storyBody" -->
<!--       :storyReference="customerStories[0].storyReference" -->
<!--       :storyReferenceLink="customerStories[0].storyReferenceLink" -->
<!--       :storyBgImgSrc="customerStories[0].storyBgImgSrc" -->
<!--       :storyImgSrc="customerStories[0].storyImgSrc" -->
<!--       :storyImgAlt="customerStories[0].storyImgAlt" -->
<!--       :storyImgLink="customerStories[0].storyImgLink" /> -->
      
    <service-ad
      id="Services"
      v-observe-visibility="sectionVisibilityChanged"
      :serviceAd="serviceAds[0]" />  
      
    <services-showcase style="margin-top:1px;"
      id="Services2"
      v-observe-visibility="sectionVisibilityChanged"
      :services="services.slice(0,3)"/>
    
    <service-ad
      id="Services3"
      v-observe-visibility="sectionVisibilityChanged"
      :serviceAd="serviceAds[1]" />  
    
<!--     <services-showcase style="margin-top:1px;" -->
<!--       id="Services2" -->
<!--       v-observe-visibility="sectionVisibilityChanged" -->
<!--       :services="services.slice(3,6)"/> -->
<!--     <portfolio -->
<!--       id="Portfolio" -->
<!--       v-observe-visibility="sectionVisibilityChanged" -->
<!--       :portfolioItems="portfolioItems" /> -->
     

<!--     <customer-story  -->
<!--       rightAligned -->
<!--       :storyTitle="customerStories[2].storyTitle" -->
<!--       :storyBody="customerStories[2].storyBody" -->
<!--       :storyReference="customerStories[2].storyReference" -->
<!--       :storyReferenceLink="customerStories[2].storyReferenceLink" -->
<!--       :storyBgImgSrc="customerStories[2].storyBgImgSrc" -->
<!--       :storyImgSrc="customerStories[2].storyImgSrc" -->
<!--       :storyImgAlt="customerStories[2].storyImgAlt" -->
<!--       :storyImgLink="customerStories[2].storyImgLink" /> -->
<!--     <references -->
<!--       id="References" -->
<!--       v-observe-visibility="visibilityChanged" -->
<!--       :referenceItems="referenceItems" /> -->
     
<!--     <customer-story  -->
<!--       :storyTitle="customerStories[2].storyTitle" -->
<!--       :storyBody="customerStories[2].storyBody" -->
<!--       :storyReference="customerStories[2].storyReference" -->
<!--       :storyReferenceLink="customerStories[2].storyReferenceLink" -->
<!--       :storyBgImgSrc="customerStories[2].storyBgImgSrc" -->
<!--       :storyImgSrc="customerStories[2].storyImgSrc" -->
<!--       :storyImgAlt="customerStories[2].storyImgAlt" -->
<!--       :storyImgLink="customerStories[2].storyImgLink" /> -->
    
<!--    <contact-form
      id="Contact"
      v-observe-visibility="sectionVisibilityChanged" />
-->

    <site-footer />
  </div>
</template>

<script>
import {
  
} from 'mdbvue'
import SiteNav from '@/components/SiteNav.vue'
import CompanyIntro from '@/components/CompanyIntro.vue'
import ServicesShowcase from '@/components/ServicesShowcase.vue'
import ServiceAd from '@/components/ServiceAd.vue'
// import CustomerStory from '@/components/CustomerStory.vue'
// import Portfolio from '@/components/Portfolio.vue'
// import References from '@/components/References.vue'
import ContactForm from '@/components/ContactForm.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'app',
  metaInfo() {
    return {
      title: 'Amnehagen IT AB',
      titleTemplate: '%s - Home',
      htmlAttrs: {
        lang: 'en',
        amp: true
      },
      meta: [
        {
          charset: 'utf-8' 
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1'
        },
        {
          name: 'description',
          content: 'IT Consulting services. Maintenance, Hosting, Software development, appdesign and more!'
        },
        {
          name: 'robots',
          content: 'index, follow'
        },
        {
          name: 'keywords',
          content: 'consult,consulting,it,development,system,software,web,app,apps,website,project,game,games,recruit,employ'
        }
      ]
    }
  },
  components: {
    SiteNav,
    CompanyIntro,
    ServicesShowcase,
    ServiceAd,
//     CustomerStory,
//     Portfolio,
//     References,
    ContactForm,
    SiteFooter
  },
  data() {
    return {
      navItems: [
        { 
          name: "Home", 
          isVisible: false 
        },
        { 
          name: "Services", 
          isVisible: false 
        },
//         { 
//           name: "Portfolio", 
//           isVisible: false 
//         },
// //         { 
// //           name: "References", 
// //           isVisible: false 
// //         },
//        { 
//          name: "Contact", 
//          isVisible: false 
//        }
      ],
      services: [
        {
          image: require('@/assets/skill-connected-globe.png'),
          imageAlt: 'alt1',
          title: 'Software Development',
          body: 'With experience in a wide range of modern and widely used technology stacks we can deliver solutions to almost any system. Be it web, embedded, server or desktop.'
        },
        {
          image: require('@/assets/skill-data.png'),
          imageAlt: 'alt2',
          title: 'Infrastructure Hosting',
          body: 'So you’re moving or <i>streamlining</i> your <strong>IT infrastructure</strong>?<br />With our competence in areas such as <strong>Virtualization</strong>, <strong>Containerization</strong>, <strong>CI/CD</strong> and more, we can aid you in any relocation or renewal project.'
        },
        {
          image: require('@/assets/skill-tools.png'),
          imageAlt: 'alt3',
          title: 'Tech Support and Maintenance',
          body: 'Maintenance of existing infrastructure, upgrades, updates or migrations.<br /><strong>We are your people!</strong><br />We possess expertise in multiple platforms, such as <strong>Debian Linux</strong> and <strong>Microsoft Windows Server</strong>.'
        },
        {
          image: require('@/assets/skill-tools.png'),
          imageAlt: 'alt1',
          title: 'Tools & Utilities2',
          body: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don&quote;t look even slightly believable.'
        },
        {
          image: require('@/assets/skill-data.png'),
          imageAlt: 'alt2',
          title: 'Storage & Databases2',
          body: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn&quote;t anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.'
        },
        {
          image: require('@/assets/skill-linux.png'),
          imageAlt: 'alt3',
          title: 'Native & Web Apps2',
          body: 'Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites.'
        }
      ],
      customerStories: [
        {
          storyTitle: 'Implementing a central company information hub, a wiki.',
          storyBody: 'Do you feel like you answer the same questions over and over, put the answers in searchable text-form in you own wiki.<br /><br /><strong>We can set it up for you!<strong><br /><br />Either on your own servers or hosted by us using our VPS Hosting service that is specifically tailored to your needs.',
          storyReference: 'Lorem Impsum generator, 2019 1',
          storyReferenceLink: 'https://www.lipsum.com/',
          storyBgImgSrc: 'https://drscdn.500px.org/photo/201353937/m%3D900/v2?webp=true&sig=c37cbcaf3f0fa0d25c62015fcbe0574af98dddc5a9884fbb023de9292525efef',
          storyImgSrc: 'https://www.computerhope.com/cdn/excel.jpg',
          storyImgAlt: 'gif loop1',
          storyImgLink: 'https://media.giphy.com/media/FPbncvEo8wkVWAB9cy/giphy.gif'
        }
      ],
      serviceAds: [
        {
          title: 'Managing Content Management Systems',
          body: 'Many modern websites are set up using CMS’s like <strong>Wordpress</strong>, <strong>Drupal</strong> or <strong>Magento</strong>. This may in some cases lessen the development time of the site and puts more power into the site owners’ hands; having an admin section for editing some site content.<br /><br />In new projects, <strong>we assess your needs</strong> for your site. Be it a responsive web app advertising a cooking class, or a company business profile, we then suggest the technology to use. It might be a CMS or even writing code from scratch for a more specialized implementation.<br /><br />Talk with us about managing your <strong>Content Managagement Systems</strong>.',
          backgroundImage: require('@/assets/laptop-computers-1236114-1919x1112.jpg'),
          backgroundVideo: '',
          fixedPositionBackground: false,
          images: [
            {
              src: require('@/assets/cms-logo-wordpress.png'),
              alt: '',
              link: ''
            },
            {
              src: require('@/assets/cms-logo-drupal.png'),
              alt: '',
              link: ''
            },
            {
              src: require('@/assets/cms-logo-magento.png'),
              alt: '',
              link: ''
            }
          ],
          videos: [],
          circularImage: true,
          imageShadow: true,
          scrollToContactButton: true,
          rightAligned: false
        },
        {
          title: 'Centralized Documentation',
          body: 'Is it possible to <strong>answer questions proactively</strong>? Yes it is!<br /><br />With well written documentation in <strong>easily accessible</strong> and <strong>searchable</strong> form, you can!<br /><br/>Some companies have printed ledgers, documents scattered across shared directories and email, but not you, you know better.<br /><br />Centralizing documentation in a secure digital is a big step in internal or external documentation. Be it for a project, recipies or internal procedures we set it up for you using the widely used <strong>MediaWiki</strong> platform; the very <strong>same that Wikipedia uses</strong>!',
          backgroundImage: require('@/assets/laptop-computers-1236114-1919x1112.jpg'),
          backgroundVideo: '',
          fixedPositionBackground: false,
          images: [
            {
              src: require('@/assets/mediawiki-384.png'),
              alt: '',
              link: ''
            },
            {
              src: require('@/assets/business-graphics-1236430-640x640.jpg'),
              alt: '',
              link: ''
            },
            {
              src: require('@/assets/business-graphics-1056973-640x640.jpg'),
              alt: '',
              link: ''
            }
          ],
          videos: [],
          circularImage: true,
          imageShadow: true,
          scrollToContactButton: true,
          rightAligned: false
        },
        {
          title: 'Cutting licensing costs',
          body: 'Some companies mainly recommend <strong>Expensive Licensed Software</strong>, however, we try to find equivalent or better solutions in the <strong>Open Source</strong> space. <br />We are a <strong>Linux Positive</strong> group of people, using <strong>professional tools</strong> that doesn’t cost your grandfather’s fortune and a half.<br /><br />We should open a dialogue about what we can do for your organization.',
          backgroundImage: require('@/assets/laptop-computers-1236114-1919x1112.jpg'),
          backgroundVideo: '',
          fixedPositionBackground: false,
          images: [
            {
              src: require('@/assets/money-matters-1173114-639x426.png'),
              alt: '',
              link: ''
            },
            {
              src: require('@/assets/money-matters-1173120-639x426.png'),
              alt: '',
              link: ''
            }
          ],
          videos: [],
          circularImage: true,
          imageShadow: true,
          scrollToContactButton: true,
          rightAligned: true
        }
      ],
      portfolioItems: [
        {
          isLarge: true,
          images: [
            {
              url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEMDDUtyQnzW3jTyVmub0sAeO311YQfh6CAUoXPhHYq5sx6wnK4A',
              alt: ''
            },
            {
              url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHSyEsdZLFvih09VO65nT_sH5yeDsuIr50W4Yj0sNant5le0a2',
              alt: ''
            }
          ],
          title: 'Integer aliquam dapibus enim',
          excerpt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae sapien a dolor iaculis tincidunt. Pellentesque condimentum neque eget est aliquet, in semper tortor bibendum.',
          body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae sapien a dolor iaculis tincidunt. Pellentesque condimentum neque eget est aliquet, in semper tortor bibendum. Aliquam aliquet purus sed nisl tristique, eu feugiat odio lobortis. Phasellus bibendum luctus turpis, eget feugiat nisi sollicitudin ac. Morbi aliquet et odio sit amet facilisis. Nullam nulla leo, dictum sit amet mauris ut, vestibulum feugiat ligula. Quisque bibendum orci non dapibus sodales.',
          links: [
            {
              url: 'https://www.lipsum.com/feed/html',
              text: 'Lorem Ipsum generator'
            }
          ]
        
        },
        {
          isLarge: true,
          images: [
            {
              url: 'https://asc.army.mil/web/wp-content/uploads/2017/09/cerdec-auto-tech.jpg',
              alt: ''
            },
            {
              url: 'https://upload.wikimedia.org/wikipedia/commons/f/fe/Mexico_Product_Export_Treemap.jpg',
              alt: ''
            }
          ],
          title: 'Phasellus vitae sapien a dolor',
          excerpt: 'Integer aliquam dapibus enim, sed porta lorem lacinia vel. Quisque scelerisque erat vel orci facilisis, nec blandit leo dapibus. Aenean tristique sit amet eros et aliquet.',
          body: 'Integer aliquam dapibus enim, sed porta lorem lacinia vel. Quisque scelerisque erat vel orci facilisis, nec blandit leo dapibus. Aenean tristique sit amet eros et aliquet. Etiam ornare consectetur sapien, vitae sodales magna congue sit amet. Vestibulum aliquet, magna nec faucibus porttitor, diam lorem tempus velit, finibus consequat diam nunc eu orci. Mauris eget ante ut mi varius condimentum semper id urna. Suspendisse condimentum risus urna, sit amet congue velit dignissim sit amet. Vestibulum gravida sollicitudin porta.',
          links: [
            {
              url: 'https://www.lipsum.com/feed/html',
              text: 'Lorem Ipsum generator'
            },
            {
              url: 'https://www.google.com/',
              text: 'Google search'
            },
          ]
        
        },
        {
          isLarge: false,
          images: [
            {
              url: 'https://images.pexels.com/photos/34600/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
              alt: ''
            },
            {
              url: 'https://www.navsea.navy.mil/Portals/103/Images/Exhibits/SAS2019/190506-N-QE653-032.jpg',
              alt: ''
            }
          ],
          title: '1Nullam vehicula nibh at nunc varius',
          excerpt: '1Praesent dapibus pulvinar rhoncus. Nullam vehicula nibh at nunc varius euismod ac a tortor.',
          body: '1Praesent dapibus pulvinar rhoncus. Nullam vehicula nibh at nunc varius euismod ac a tortor. Donec vehicula ex at felis volutpat, eu mattis ipsum sagittis. Vivamus eget gravida nunc. Nulla purus dui, gravida finibus odio sit amet, fringilla efficitur enim. Proin eget nisl vel libero lacinia gravida et sit amet ligula. Donec posuere, turpis a consequat egestas, nibh velit iaculis massa, at mattis est orci non mi. Vestibulum sagittis tincidunt egestas. Donec in laoreet nunc. Phasellus in risus dui. Donec non nulla nunc. Quisque odio nulla, condimentum semper nulla a, fringilla lacinia neque. In vitae erat vitae felis luctus mollis. Integer cursus, ante et posuere efficitur, mi sapien posuere ex, quis accumsan ante erat id elit. Mauris sit amet augue pretium elit egestas malesuada.',
          links: [
            {
              url: 'https://www.google.com/',
              text: 'Google search'
            },
            {
              url: 'https://www.lipsum.com/feed/html',
              text: 'Lorem Ipsum generator'
            }
          ]
        
        },
        {
          isLarge: false,
          images: [
            {
              url: 'https://upload.wikimedia.org/wikipedia/en/thumb/5/50/Why_Who_How.jpg/800px-Why_Who_How.jpg',
              alt: ''
            },
            {
              url: 'https://www.navsea.navy.mil/Portals/103/Images/Exhibits/SAS2019/190506-N-QE653-032.jpg',
              alt: ''
            }
          ],
          title: '2Nullam vehicula nibh at nunc varius',
          excerpt: '2Praesent dapibus pulvinar rhoncus. Nullam vehicula nibh at nunc varius euismod ac a tortor.',
          body: '2Praesent dapibus pulvinar rhoncus. Nullam vehicula nibh at nunc varius euismod ac a tortor. Donec vehicula ex at felis volutpat, eu mattis ipsum sagittis. Vivamus eget gravida nunc. Nulla purus dui, gravida finibus odio sit amet, fringilla efficitur enim. Proin eget nisl vel libero lacinia gravida et sit amet ligula. Donec posuere, turpis a consequat egestas, nibh velit iaculis massa, at mattis est orci non mi. Vestibulum sagittis tincidunt egestas. Donec in laoreet nunc. Phasellus in risus dui. Donec non nulla nunc. Quisque odio nulla, condimentum semper nulla a, fringilla lacinia neque. In vitae erat vitae felis luctus mollis. Integer cursus, ante et posuere efficitur, mi sapien posuere ex, quis accumsan ante erat id elit. Mauris sit amet augue pretium elit egestas malesuada.',
          links: [
            {
              url: 'https://www.google.com/',
              text: 'Google search'
            },
            {
              url: 'https://www.lipsum.com/feed/html',
              text: 'Lorem Ipsum generator'
            }
          ]
        
        },
        {
          isLarge: false,
          images: [
            {
              url: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/Big_Buck_Bunny_thumbnail_vlc.png',
              alt: ''
            },
            {
              url: 'https://www.navsea.navy.mil/Portals/103/Images/Exhibits/SAS2019/190506-N-QE653-032.jpg',
              alt: ''
            }
          ],
          title: '3Nullam vehicula nibh at nunc varius',
          excerpt: '3Praesent dapibus pulvinar rhoncus. Nullam vehicula nibh at nunc varius euismod ac a tortor.',
          body: '3Praesent dapibus pulvinar rhoncus. Nullam vehicula nibh at nunc varius euismod ac a tortor. Donec vehicula ex at felis volutpat, eu mattis ipsum sagittis. Vivamus eget gravida nunc. Nulla purus dui, gravida finibus odio sit amet, fringilla efficitur enim. Proin eget nisl vel libero lacinia gravida et sit amet ligula. Donec posuere, turpis a consequat egestas, nibh velit iaculis massa, at mattis est orci non mi. Vestibulum sagittis tincidunt egestas. Donec in laoreet nunc. Phasellus in risus dui. Donec non nulla nunc. Quisque odio nulla, condimentum semper nulla a, fringilla lacinia neque. In vitae erat vitae felis luctus mollis. Integer cursus, ante et posuere efficitur, mi sapien posuere ex, quis accumsan ante erat id elit. Mauris sit amet augue pretium elit egestas malesuada.',
          links: [
            {
              url: 'https://www.google.com/',
              text: 'Google search'
            },
            {
              url: 'https://www.lipsum.com/feed/html',
              text: 'Lorem Ipsum generator'
            }
          ]
        
        }
      ],
      referenceItems: [
        {
          images: [
            {
              src: require('@/assets/references/anton-bengtsson.jpeg'),
              alt: 'Anton Bengtsson Photo'
            }
          ],
          name: 'Anton Bengtsson',
          title: 'IT Manager at Tangiamo Touch Technology AB (2018 - ...)',
          quote: 'Delivered on time!',
          contactOptions: [
            {
              icon: 'envelope',
              url: 'mailto:anton@antonbengtsson.net'
            },
            {
              fab: true,
              icon: 'linkedin',
              url: 'https://www.linkedin.com/in/anton-bengtsson-08723715a/',
              newTab: true
            },
            {
              icon: 'globe',
              url: 'http://antonbengtsson.net/',
              newTab: true
            }
          ]
        },
        {
          images: [
            {
              src: require('@/assets/references/jimmy-eiterjord.jpeg'),
              alt: 'Anton Bengtsson Photo'
            }
          ],
          name: 'Anton Bengtsson',
          title: 'IT Manager at Tangiamo Touch Technology AB (2018 - ...)',
          quote: 'Overdue, works well.',
          contactOptions: [
            {
              icon: 'envelope',
              url: 'mailto:anton@antonbengtsson.net'
            },
            {
              fab: true,
              icon: 'linkedin',
              url: 'https://www.linkedin.com/in/anton-bengtsson-08723715a/',
              newTab: true
            },
            {
              icon: 'globe',
              url: 'http://antonbengtsson.net/',
              newTab: true
            }
          ]
        },
        {
          images: [
            {
              src: require('@/assets/references/linh-thai.jpeg'),
              alt: 'Anton Bengtsson Photo'
            }
          ],
          name: 'Anton Bengtsson',
          title: 'IT Manager at Tangiamo Touch Technology AB (2018 - ...)',
          quote: 'Better than planned!',
          contactOptions: [
            {
              icon: 'envelope',
              url: 'mailto:anton@antonbengtsson.net'
            },
            {
              fab: true,
              icon: 'linkedin',
              url: 'https://www.linkedin.com/in/anton-bengtsson-08723715a/',
              newTab: true
            },
            {
              icon: 'globe',
              url: 'http://antonbengtsson.net/',
              newTab: true
            }
          ]
        },
        {
          images: [
            {
              src: require('@/assets/references/nicklas-andreasson.jpeg'),
              alt: 'Anton Bengtsson Photo'
            }
          ],
          name: 'Anton Bengtsson',
          title: 'IT Manager at Tangiamo Touch Technology AB (2018 - ...)',
          quote: 'Delivered according to plan!',
          contactOptions: [
            {
              icon: 'envelope',
              url: 'mailto:anton@antonbengtsson.net'
            },
            {
              fab: true,
              icon: 'linkedin',
              url: 'https://www.linkedin.com/in/anton-bengtsson-08723715a/',
              newTab: true
            },
            {
              icon: 'globe',
              url: 'http://antonbengtsson.net/',
              newTab: true
            }
          ]
        }
      ]
    }
  },
  methods: {
    sectionVisibilityChanged: function (isVisible, entry) {
      // Set visibility of section
      this.navItems.map((item) => item.name === entry.target.id ? item.isVisible = isVisible : null)
    },
//     isMobile: function() {
//       // https://jsfiddle.net/Ldku0xec/
//       var check = false;
//       (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//       return check;
//     }
  }
}

// https://iso.500px.com/how-to-capture-moody-misty-mountain-photos/
</script>

<style>
html,
body,
header {
    height: 100%;
}

body {
  background-color: #4d4d4d;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #DEDEDE;
/*   margin-top: 60px; */
  width: 100%;
  height: 100%;
}

.scrollToHidden {
  color: green;
}

/* Override bootstrap */
/* Fix for missing funcitonality, in wait of patches. */
.btn-rounded {
  border-radius: 10em;
}

.force-circular-border {
  border-radius: 50% !important;
}
.force-circular-border img {
  border-radius: 50% !important;
}

.modal-dialog {
  background-color: rgba(0,0,0,0);
}

/* Fix broken corners. */
.modal-content {
  background-color: rgba(0,0,0,0);
}
</style>
